"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _get = _interopRequireDefault(require("transmute/get"));

var _ReferenceRecord = _interopRequireDefault(require("reference-resolvers/schema/ReferenceRecord"));

var getContact = (0, _get.default)('contact');
var getError = (0, _get.default)('error');
var getEmailAddress = (0, _get.default)('emailAddress');

var formatReferencedObject = function formatReferencedObject(item) {
  return (0, _immutable.fromJS)(getError(item) ? null : getContact(item));
};

var _default = function _default(contactResponses) {
  return (0, _immutable.List)(contactResponses.map(function (item) {
    return new _ReferenceRecord.default({
      id: getEmailAddress(item),
      label: getEmailAddress(item),
      referencedObject: formatReferencedObject(item)
    });
  }));
};

exports.default = _default;
module.exports = exports.default;